<template>
<div class="mobilePayment botPage">
  <mbHeader :title="$t('payment_manage')" :left="true" :lang="true"></mbHeader>
  <payment></payment>
</div>
</template>

<script>

import mbHeader from "../../components/mobile/mbHeader";
import payment from "../Profile/payment";

export default {
  name: "mobilePayment",
  components: {mbHeader,payment},
}
</script>

<style scoped lang="less">
.mobilePayment{
  min-height: 100vh;
  padding: 50px 0;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobilePayment.vue